import { Injectable, OnDestroy } from '@angular/core';
import { RxEmitter } from '../rxjs/rx-emitter';
import { Subscription } from 'rxjs';
import { rcEventRoutes } from '../common/constants/remote-control';
import { CoolLocalStorage } from '@angular-cool/storage';
import { KeyboardCombos } from 'common/common/constants/keyboard-combos';
import { assign } from 'lodash';

export const SHORTCUT_AVAILABILITY_STORAGE_KEY = 'shortcut-availability';

@Injectable({
  providedIn: 'root'
})
export class KeyboardAvailabilityService implements OnDestroy {
  private _isAvailable: boolean = true;
  private _remoteControlSubscription: Subscription;
  private _availabilityStates;

  constructor(private _rxEmitter: RxEmitter, private _localStorage: CoolLocalStorage) {
    this._availabilityStates = {
      [KeyboardCombos.CtrlAltI]: true,
      [KeyboardCombos.CtrlAltK]: true,
      [KeyboardCombos.CtrlAltJ]: true,
      [KeyboardCombos.CtrlAltL]: true,
      [KeyboardCombos.CtrlAltM]: true,
      [KeyboardCombos.CtrlAltN]: true,
      [KeyboardCombos.CtrlAltH]: true
    };

    this._subscribeToRemoteControlStates();
    this._initShortcutAvailability();
  }

  ngOnDestroy(): void {
    if (this._remoteControlSubscription) {
      this._remoteControlSubscription.unsubscribe();
      this._remoteControlSubscription = null;
    }
  }

  get areShortcutsAllowed() {
    return this._isAvailable;
  }

  isShortcutDisabled(shortcut: string): boolean {
    return !this._availabilityStates[shortcut] && this._availabilityStates[shortcut] !== undefined;
  }

  toggleShortcutAvailability(shortcut: string) {
    this._availabilityStates[shortcut] = !this._availabilityStates[shortcut];
    this._saveToStorage();
  }

  private _subscribeToRemoteControlStates() {
    this._remoteControlSubscription = this._rxEmitter.subscribe(rcEventRoutes.globalKeyboardSubscriptionChange, this._handleRemoteControlGlobalKeyboardBindingChanges.bind(this));
  }

  private _handleRemoteControlGlobalKeyboardBindingChanges(remoteControlHasSubscribedToKeyEvents: boolean) {
    this._isAvailable = !remoteControlHasSubscribedToKeyEvents;
  }

  private _initShortcutAvailability(): void {
    this._availabilityStates = assign(this._availabilityStates, this._loadFromStorage());

    this._saveToStorage();
  }

  private _loadFromStorage() {
    return this._localStorage.tryGetObject(SHORTCUT_AVAILABILITY_STORAGE_KEY);
  }

  private _saveToStorage() {
    this._localStorage.setObject(SHORTCUT_AVAILABILITY_STORAGE_KEY, this._availabilityStates);
  }
}
